import { useNavigate } from 'react-router-dom';
import '../App.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UserLayot from '../Componets/UserLayout';
import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from 'axios';

export default function Home(p) {
  const navigate = useNavigate();
  const [examsCount, setExamsCount] = useState(0);
  const [anssheetCount, setAnssheetCount] = useState(0);
  const [reassesCount, setReassesCount] = useState(0);
  const [sheetCount, setSheetCount] = useState(0);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [dashboardCount, setDashboardCount] = useState(null);
  //check for login or not
  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'USER') {
      // Adjusted comparison to match the role stored in localStorage
      navigate('/');
    }
    // eslint-disable-next-line
  }, []);

  //  alert function to show alert when login successfully
  useEffect(() => {
    if (!localStorage.getItem('alertShown')) {
      // Show the alert
      notify();
      // Set a flag in local storage to indicate that the alert has been shown
      localStorage.setItem('alertShown', 'true');
    }
    // eslint-disable-next-line
  }, []);

  const notify = () => toast.success('Login successfully');
  // States to manage the counters

  // Function to handle counter animation
  const animateCounter = (target, setCount) => {
    let start = 0;
    const increment = target / 100; // Increment over 100 steps
    const interval = setInterval(() => {
      start += increment;
      if (start >= target) {
        clearInterval(interval);
        setCount(target); // Set final value
      } else {
        setCount(Math.ceil(start));
      }
    }, 10); // Interval speed
  };

  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: 'ease-in-out',
      once: true,
      mirror: false,
      devtool: false,
    });
    AOS.refresh();
  }, []);
  useEffect(() => {
    const fetchRecords = async () => {
      const token = localStorage.getItem('token');
      try {
        const response = await axios.get(`${apiUrl}/api/dashboard/user`, {
          headers: {
            Authorization: token,
          },
        });
        setDashboardCount(response.data); // Set dashboard data
      } catch (error) {
        console.error(error.response.data.message);
        error.response?.status === 401 && navigate('/');
      }
    };

    fetchRecords();
  }, [apiUrl]);

  // Animate counters when component mounts
  useEffect(() => {
    if (dashboardCount) {
      animateCounter(dashboardCount.totalExams, setExamsCount);
      animateCounter(dashboardCount.totalAnsweeSheet, setAnssheetCount);
      animateCounter(dashboardCount.totalRessamentExams, setReassesCount);
      animateCounter(dashboardCount.totalRessamentAnsweeSheet, setSheetCount);
    }
  }, [dashboardCount]); // Trigger once on component mount

  return (
    <UserLayot ac1="active">
      <main id="main" className="main">
        <div className="pagetitle mb-4">
          <h1>Dashboard</h1>
        </div>

        {/* ------------------------------------------  Page  ---------------------------- */}
        <section id="stats" className="stats section">
          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <div className="row gy-4">
              <div
                className="col-lg-3 col-md-6 cursor-pointer"
                onClick={() => navigate('/AnswerSheet')}
              >
                <div className="stats-item d-flex align-items-center w-100 h-100">
                  <i className="bi bi-journal-bookmark-fill color-blue flex-shrink-0"></i>
                  <div>
                    <span>{examsCount}</span>
                    <p>Exams</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 ">
                <div className="stats-item d-flex align-items-center w-100 h-100">
                  <i
                    className="bi bi-journal-text color-orange flex-shrink-0"
                    style={{ color: '#ee6c20' }}
                  ></i>
                  <div>
                    <span>{anssheetCount}</span>
                    <p> Answersheet</p>
                  </div>
                </div>
              </div>

              <div
                className="col-lg-3 col-md-6 cursor-pointer"
                onClick={() => navigate('/ReassExams')}
              >
                <div className="stats-item d-flex align-items-center w-100 h-100">
                  <i
                    className="bi bi-bootstrap-reboot color-green flex-shrink-0"
                    style={{ color: '#15be56' }}
                  ></i>
                  <div>
                    <span>{reassesCount}</span>
                    <p>Reasses. Exam</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 ">
                <div className="stats-item d-flex align-items-center w-100 h-100">
                  <i
                    className="bi bi-journal-medical color-pink flex-shrink-0"
                    style={{ color: 'bb0852' }}
                  ></i>
                  <div>
                    <span>{sheetCount}</span>
                    <p>Reasses. Sheet</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ToastContainer />
      </main>
    </UserLayot>
  );
}
